<template lang="pug">
  content-video(
    :videos="mappedCards"
  )
    template(
      v-if="!readonly"
      #slideActions="{ hover, idx }"
    )
      v-btn(
        v-if="hover"
        color="secondary"
        fab
        depressed
        x-small
        style="position: absolute; left: 0; top: 34%;"
        @click="addVideo(idx)"
      )
        h1.font-weight-bold +
      v-btn(
        v-if="hover"
        color="secondary"
        fab
        depressed
        x-small
        style="position: absolute; right: 0; top: 34%;"
        @click="addVideo(idx + 1)"
      )
        h1.font-weight-bold +
      v-btn.btn-remove(
        v-if="hover"
        color="error darken-1"
        depressed
        x-small
        fab
        style="position: absolute; right: 0; bottom: 0;"
        @click="removeVideo(idx)"
      )
        v-icon mdi-delete
    template(#no-data)
      .text-center(v-if="!readonly")
        v-btn(color="primary" @click="addVideo" outlined).mx-auto Добавить видео
</template>
<script>
import ConstructorCard from '@/models/list/ConstructorCard';
import ContentVideo from '@/modules/Education/Courses/components/LessonContent/ContentVideos.vue';
import CAddLink from './СAddLink.vue';
import { CARD_TYPES } from './constants';

export default {
  components: {
    ContentVideo,
  },
  props: {
    // Array of Cards
    cardsValues: { type: Array, default: null },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {

    };
  },
  computed: {
    cards: {
      get() {
        return this.cardsValues;
      },
      set(value) {
        this.$emit('update:cards', value);
      },
    },
    mappedCards() {
      return this.cards.map((card) => ({
        name: card.title,
        link: card.url,
      }));
    },
  },
  methods: {
    addVideo(positionIdx) {
      this.$modals.show('generic-controller', {
        title: 'Добавить видео',
        component: CAddLink,
        'component-props': {
          type: CARD_TYPES.video,
          success: (link) => {
            this.cards.splice(positionIdx, 0, new ConstructorCard(link));
            this.$modals.close();
          },
        },
      });
    },
    removeVideo(positionIdx) {
      const cards = [...this.cardsValues];
      cards.splice(positionIdx, 1);
      this.$emit('update:cards', cards);
      this.$modals.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-remove {
      opacity: .5;
      transition: all .2s;

    &:hover {
      opacity: 1;
    }
}
</style>
